<div class="page-wrapper">
  <div class="container login-container">
    <div class="login-page">
      <div class="login-left">
        <h1>{{ 'The environmental management platform for heavy industrial companies' | translate }}</h1>
        <h6>{{ 'We reduce health and environmental risks by combining real-time dust sensors with intelligent air quality software.' | translate }}</h6>
        <div class="ripple">
          <img src="../../../assets/images/ripple-bg.png">
        </div>
      </div>
      <div class="login-right">
        <div class="login-form">
          <div class="d-flex justify-content-between">
            <div class="logo-form">
              <img src="../../../assets/images/new-logo.png">
            </div>
            <app-language-switcher></app-language-switcher>
          </div>

          <br />
          <br />
          <br />
          @if (!showMFA) {
            <span class="Log-in-to-your-accou">
              {{ 'Log in to APT Dashboard' | translate }}
            </span>
            <form class="mt-2" [formGroup]="loginForm" (ngSubmit)="loginHandler()">
              <div class="form-group">
                <input type="email" formControlName="loginId" id="username" name="username"
                  autocomplete="username" placeholder="{{ 'Email ID' | translate }}" class="form-control">
                  <span class="form-control-icon"><img src="assets/images/account_circle.png"></span>
                </div>
                <div class="form-group">
                  <input type="password" formControlName="password" id="password" name="password"
                    autocomplete="current-password" placeholder="{{ 'Password' | translate }}"
                    class="form-control">
                    <span class="form-control-icon"><img src="assets/images/lock_black.png"></span>
                  </div>
                  <div class="form-group forgot-password">
                    <a (click)="navigateToForgotpassword()" class="forgot-password">{{ 'Forgot Password?' | translate }}</a>
                  </div>
                  <div class="form-group remember-password d-flex">
                    <div class="checkbox-container">
                      <input type="checkbox" name="R-password" value="r-password" [checked]="rememberMe"
                        (change)="rememberMeChanged($event)">
                        <span class="checkmark" (click)="$event.stopPropagation();"></span>
                      </div>
                      <label for="R-password">{{ 'Remember Password' | translate }}</label><br>
                    </div>
                    <div class="form-group">
                      <input type="submit" value="{{ 'Continue' | translate }}">
                    </div>
                  </form>
                }
                @if (showMFA) {
                  <span class="Log-in-to-your-accou">
                    {{ (isForcedEnrollment ? 'Set up multi-factor authentication' : 'Enter OTP') | translate }}
                  </span>
                  @if (isForcedEnrollment) {
                    <p>{{ 'Your role now requires multi-factor authentication. We sent a code to your email — enter it below to finish signing in.' | translate }}</p>
                  }
                  <form class="mt-2" [formGroup]="MFAForm" (ngSubmit)="MFASubmit()">
                    <div class="form-group">
                      <input type="text" formControlName="otp" placeholder="{{ 'Enter OTP' | translate }}" class="form-control">
                    </div>
                    <div class="form-group">
                      <input type="submit" value="{{ 'Continue' | translate }}">
                    </div>
                  </form>
                }
                @if (!showMFA) {
                  <div>
                    <div class="row vertical-align-middle">
                      <div class="col-md-5">
                        <hr>
                        </div>
                        <div class="col-md-1 mt-2 text-center">{{ 'or' | translate }}</div>
                        <div class="col-md-5">
                          <hr>
                          </div>
                        </div>
                        <div class="oauth-login-btn" (click)="loginWithMicrosoft()">
                          <img src="../../../assets/images/microsoft.png">
                          <span class="text">{{ 'Continue with Microsoft' | translate }}</span>
                        </div>
                        <!-- Empty div till google/other button is there -->
                        <div class="oauth-login-btn"></div>
                        <!--<div id="googleBtnDiv" class="">
                        <img src="../../../assets/images/google.png">
                        <span class="text">Continue with Google</span>
                      </div>-->
                    </div>
                  }

                  <div class="user-terms-section">
                    {{ 'By clicking "Continue" you agree to Applied Particle Technology\'s' | translate }}
                    <a target="_blank" href="https://www.appliedparticletechnology.com/terms-of-services">{{ 'User Terms of Service' | translate }}</a>
                    {{ 'and' | translate }}
                    <a target="_blank" href="https://www.appliedparticletechnology.com/privacy-policy">{{ 'Privacy Notice' | translate }}</a>.
                  </div>
                </div>
              </div>
            </div>

            <footer>
              <div class="container ml-2">
                <p><app-copyright></app-copyright></p>
              </div>
            </footer>
          </div>
        </div>
